import { useLoginWithCV } from 'api/hooks/useLoginWithCV';
import { Button } from 'components/button';
import FileUploadWithProgress from 'components/uploader/fileUploaderWithProgress';
import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { jotaiStore } from 'store';
import { BackspaceIcon } from '@heroicons/react/24/solid';
import {
    ArrowLeftIcon,
    ChevronDoubleLeftIcon,
    ChevronLeftIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from 'utilities/auth';
import { useNavigate } from 'react-router-dom';
import Spinner from 'components/Spinner';
import ChoosePassword from './_components/choosePassword';
import EnterPassword from './_components/password';

export default function SignInCV() {
    const { isAuthenticated, isLoading, loginWithCode } = useAuth();

    const [uploadProgress, setUploadProgress] = useState(0);
    const [error, setError] = useState<string | undefined>();
    const [auth, setAuth] = useAtom(jotaiStore.authAtom);
    const [choosePassword, setChoosePassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { mutate, isPending } = useLoginWithCV((p) => {
        setUploadProgress(Math.round((p.progress as number) * 100));
    });
    const navigate = useNavigate();
    useEffect(() => {
        if (isAuthenticated)
            navigate('/', {
                replace: true,
            });
    }, [isAuthenticated]);

    return (
        <div className="flex min-h-screen flex-1 flex-col justify-center bg-neutral6 py-12 sm:px-6 md:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-[480px] flex flex-col gap-2">
                <div
                    onClick={() => {
                        if (choosePassword) {
                            setChoosePassword(false);
                        }
                        if (showPassword) {
                            setShowPassword(false);
                        } else {
                            window.history.back();
                        }
                    }}
                    className="flex cursor-pointer items-center text-primary-content gap-2"
                >
                    <ArrowLeftIcon className="w-6 h-6" />
                    <span>back</span>
                </div>
                <div className="bg-base-200  px-6 py-8 shadow sm:rounded-3xl sm:px-6">
                    <div className="flex flex-col gap-2">
                        <h1 className="text-primary-content text-2xl font-medium">
                            {choosePassword
                                ? 'Choose Password'
                                : showPassword
                                ? 'Sign in'
                                : 'Sign up with CV'}
                        </h1>
                        <span className="text-md">
                            {choosePassword
                                ? 'Choose password for your account'
                                : showPassword
                                ? 'Enter your account password'
                                : 'Upload your CV so we can automatically create an account for you and fill in the relevant information based on your CV'}
                        </span>
                    </div>
                    {choosePassword ? (
                        <ChoosePassword />
                    ) : showPassword ? (
                        <EnterPassword />
                    ) : (
                        <>
                            <form className="mt-3 space-y-6 relative">
                                {isPending && (
                                    <div className=" w-full h-full z-40 bg-black bg-opacity-40 rounded-2xl flex items-center justify-center absolute">
                                        <Spinner className="w-12 h-12" />
                                    </div>
                                )}
                                <FileUploadWithProgress
                                    type="PDF"
                                    title="your CV"
                                    acceptFileTypes="cv"
                                    onFileUploaded={(url) => {
                                        return true;
                                    }}
                                    mutateFunc={(...args) => {
                                        setError(undefined);
                                        mutate(...args);
                                    }}
                                    onMutateSuccess={(res) => {
                                        setUploadProgress(100);
                                        if (!res.data.shouldLogin) {
                                            const newAuth = {
                                                token: res.data.token,
                                                isLoading: false,
                                                isSuccessful: true,
                                                error: '',
                                                resp: res.data,
                                            };
                                            setAuth(newAuth);
                                            localStorage.setItem(
                                                'auth',
                                                JSON.stringify(newAuth)
                                            );
                                            setChoosePassword(true);
                                        } else {
                                            setShowPassword(true);
                                            // TODO: do somthing
                                        }
                                    }}
                                    onMutateFailed={(err) => {
                                        setError('invalid CV File');
                                    }}
                                    progress={uploadProgress}
                                />
                                {error && (
                                    <div className="label">
                                        <span className="label-text-alt text-red-500">
                                            {error}
                                        </span>
                                    </div>
                                )}

                                {/* <Button
                            // onClick={() => {
                            //     mutate({});
                            // }}
                            variant="secondary"
                            className="w-full"
                        >
                            Sign up
                        </Button> */}
                            </form>
                            <p className="mt-6 text-sm text-center">
                                By creating an account you agree with our Terms
                                of Service, Privacy Policy, and our default
                                Notification Settings.
                            </p>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
